import styled, { css } from 'styled-components';

import { Alert, Button } from '@/components/elements';
import {
  gridCalc,
  laptop,
  tabletLandscape,
  tabletPortrait,
} from '@/components/utils';
import NewsletterError from '@/icons/large/Error.svg';
import House from '@/icons/large/House.svg';
import NewsletterSuccess from '@/icons/large/Success.svg';

import { Intro } from '../Intro';
import { RichText } from '../RichText';
import { StyledProcessingSVG } from '../StatusScreen/StatusScreen.styled';
import { Wrapper } from '../Wrapper';

export const StyledContainer = styled.section`
  background-color: var(--color-newsletter-bg);
  padding-top: var(--distance-dynamic-l);
`;

export const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledWrapper = styled(Wrapper)`
  margin-bottom: var(--distance-dynamic-xl);
  padding-top: 0;
`;

export const StyledIntroIdle = styled(Intro)`
  padding-top: var(--distance-static-s);
  text-align: center;
`;

export const StyledIntro = styled(Intro)`
  padding-top: 0;
  text-align: center;
`;

const IconCss = css`
  margin-bottom: var(--distance-static-5xl);
`;

export const StyledProcessingIcon = styled(StyledProcessingSVG)`
  ${IconCss}
`;

export const StyledErrorIcon = styled(NewsletterError)`
  ${IconCss}
`;

export const StyledSuccessIcon = styled(NewsletterSuccess)`
  ${IconCss}
`;

export const StyledHouse = styled(House)`
  width: 96px;
  height: 96px;
`;

export const StyledForm = styled.form`
  @media screen and (${tabletLandscape}) {
    margin: 0 auto;
    max-width: 545px;
  }

  @media screen and (${laptop}) {
    max-width: 664px;
  }
`;

export const StyledFieldset = styled.fieldset<{ $hasConsentError: boolean }>`
  display: grid;
  gap: var(--distance-static-s);
  margin: 0 0
    ${({ $hasConsentError }) =>
      $hasConsentError
        ? 'var(--distance-static-l)'
        : 'var(--distance-static-m)'};
  border: none;
  padding: 0;

  @media screen and (${tabletPortrait}) {
    grid-template-columns: 1fr auto;
    gap: var(--distance-static-l);
  }
`;

export const StyledResultButton = styled(Button)`
  display: flex;
  margin: 0 auto;
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: var(--distance-static-l);
`;

export const StyledRichText = styled(RichText)`
  @media screen and (${laptop}) {
    max-width: ${gridCalc(12)};
  }
`;
